<template>
    <div class="mb-6 dark:bg-gray-900/70 bg-white" v-show="displayForSubscriptionPlan('starter')">
        <header class="border-gray-100 flex items-stretch border-b dark:bg-gray-900/70 dark:border-gray-800">
            <p class="flex items-center py-3 flex-grow font-bold px-6">
                <span class="icon"><i class="mdi mdi-finance"></i></span>
                Visits by Locations
            </p>
            <div class="buttons right nowrap mr-1">
                <div class="inline-flex rounded-md shadow-sm" role="group">
                    <button type="button" @click="display = 'graph'"
                            :class="display === 'graph' ? 'bg-blue-500 text-white dark:!bg-gray-900' : 'text-gray-900 bg-white'"
                            class="inline-flex items-center py-2 px-4 focus:outline-none font-medium rounded-l-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white">
                        <span class="icon"><i class="mdi mdi-chart-areaspline"></i></span>
                        <!--                    Graph-->
                    </button>
                    <button type="button" @click="display = 'list'"
                            :class="display === 'list' ? 'bg-blue-500 text-white dark:!bg-gray-900' : 'text-gray-900 bg-white'"
                            class="inline-flex items-center py-2 px-4 focus:outline-none font-medium border border-t border-gray-200 hover:bg-gray-100 hover:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white">
                        <span class="icon"><i class="mdi mdi-format-list-bulleted"></i></span>
                        <!--                    List-->
                    </button>
                    <button type="button" @click="toPDF"
                            class="inline-flex items-center py-2 px-4 focus:outline-none font-medium rounded-r-md border border-gray-200 hover:bg-gray-100 hover:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white">
                        <span class="icon"><i class="mdi mdi-file-pdf-box"></i></span>
                        <!--                    List-->
                    </button>
                </div>
            </div>
        </header>
        <div class="card-content">
            <div class="chart-area" id="elToPrint">
                <div class="h-full">
                    <div>
                        <template v-if="display === 'graph'">
                            <MapChart
                                :countryData="countryData"
                                :highColor="this.isDark?'#26867d':'#3a1143'"
                                :lowColor="isDark?'#40E0D0':'#b096b4'"
                                :countryStrokeColor="isDark?'#111827':'#ffffff'"
                                :defaultCountryFillColor="isDark?'#6B7280':'#dde4ee'"
                                :legendFontColorHeader="isDark?'#dde4ee':'#111827'"
                                :legendFontColorContent="isDark?'#dde4ee':'#111827'"
                                :legendHeaderBackgroundColor="isDark?'#111827':'#90a4ce'"
                                :legendContentBackgroundColor="isDark?'#202d49':'#d4dcec'"
                                :showEmptyValue="false"
                                :currencyAdd="false"
                            />
                        </template>
                        <template v-else>
                            <!--                            <ul class="list-none">-->
                            <table>
                                <tr>
                                    <th>Label</th>
                                    <th>Value</th>
                                </tr>
                                <template v-for="(value,index) in countryData">
                                    <tr>
                                        <td>{{ index }}</td>
                                        <td>{{ value }}</td>
                                    </tr>
                                </template>
                            </table>
                            <!--                            </ul>-->
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MapChart from 'vue-chart-map';
import html2pdf from "html2pdf.js";
import {usePage} from '@inertiajs/inertia-vue3'

export default {
    name: "LocationsGraph",
    components: {
        MapChart
    },
    props: {
        campaignCode: String,
        referrerCode: String,
        range: {
            type: String,
            default: 'daily'
        }
    },
    data() {
        return {
            display: 'graph',
            countryData: {},
            pdfOptions: {
                margin: 15,
                image: {
                    type: 'jpeg',
                    quality: 1,
                },
                html2canvas: {scale: 3},
                jsPDF: {
                    unit: 'mm',
                    format: 'a4',
                    orientation: 'p',
                },
                filename: `referex-location-${this.display}.pdf`
            },
            isDark: window.matchMedia('(prefers-color-scheme: dark)').matches
        }
    },
    methods: {
        fetchReport() {
            axios.get('/sanctum/csrf-cookie').then(response => {
                axios.get(route('report.locations', {
                    'range': this.range,
                    'campaign_code': this.campaignCode,
                    'referrer_code': this.referrerCode
                })).then((response) => {
                    this.countryData = response.data.data;
                }).catch(err => console.error(err))
            });
        },
        toPDF() {
            this.pdfOptions.filename = `referex-location-${this.display}.pdf`;

            let html = `<div style="height:100vh">
<h3 class="text-3xl text-gray-800 font-bold leading-none mb-12">Visits by location</h3>
${(document.getElementById('elToPrint')).innerHTML}
<div class="absolute left-0 right-0 bottom-2 ">Referex App &bull; ${usePage().props.value.user.name}  &bull; ${new Date()}</div>
</div>`
            const placeholder = document.createElement('div');
            placeholder.innerHTML = html;
            let el = placeholder.firstElementChild;
            html2pdf().from(el).set(this.pdfOptions).save();
        },

        detectDarkMode(event) {
            console.log("color scheme changed");
            this.isDark = window.matchMedia('(prefers-color-scheme: dark)').matches
        }
    },
    watch: {
        range: function(newVal, oldVal) { // watch it
            this.haveData = false;
            this.countryData ={};
            this.fetchReport();
        }
    },
    created() {
        this.fetchReport();
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", this.detectDarkMode);
    }
}
</script>

<style scoped>

</style>
